/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import MatrixRoom = Application.Models.MatrixRoom;
    import IBlock = Application.Models.IBlock;
    import IConnectedBlocksMap = Application.Models.IConnectedBlocksMap;
    import IBlockComplete = Application.Models.IBlockComplete;
    import BlockConnections = Application.Models.BlockConnections;

    export interface ITakeModalInput {
        src: Models.IBlockComplete;
        dst: Models.IBlockComplete;
        hasCustomTakeParameters: boolean;
        customTakeParametersInSrc: boolean;
        matrixRoom: MatrixRoom;
        prevSrcId: number;
        srcThumb: string;
        dstThumb: string;
        prevSrcThumb: string;
        prevSrcName: string;
    }

    export interface ITakeAllModalInput{
        src: Models.IBlockComplete;
        dst: Models.IBlockComplete;
        matrixRoom: MatrixRoom;
        srcThumb: string;
        dstThumb: string;
        selectedConnectionRoomGroup: Models.ConnectionRoomGroup;
        drop: boolean;
    }

    export interface ITakeModalScope extends ng.IScope {
        takeModalInput: ITakeModalInput;
        THUMBNAIL_FAIL_IMG: string;
        modalClose: (userResponse: boolean) => void;
        updatingPass:(newPassphrase: any) => void;
        updatingIp:(newPassphrase: any) => void;
        updatingPort:(newPassphrase: any) => void;
        updatingLatency:(newPassphrase: any) => void;
        updateLockedComment: (lockedComment: string) => void;
        updateLockedDestination: (lockedDestination: boolean) => void;
        passphraseError: boolean;
        ipAddressError: boolean;
        portError: boolean;
        latencyError: boolean;
        dropLock: () => void;
        checkRedundancy: () => boolean;
        changeRedundancy: () => void;
        ip: string;
        port: number;
        latency: number;
        passphrase: string;
        warningMessage: string;
        connectionValid: boolean;
        messageType: string;
        useRedundancy: boolean;
        validationIsTakingTooLong: boolean;
        validationIsTakingTooLongMessage: string;
        validated: boolean;
        matrixRoom: MatrixRoom;
        ready: boolean;
        validatePath: (sourceId: number, sinkId: number, previousSourceid: number) => void;
        validatePathWithRedundancy: (sourceId: number, sinkId: number, previousSourceid: number, secondarySourceId: number) => void;
        lockedComment: string;
        lockedDestination:boolean;
        isSwitch: boolean;
        isTake: boolean;
        showPassphrase: () => boolean;
        showLockDestination: () => boolean;
        showCustomParameters: boolean;
        secondaryTakeId: number;
        isRedundantValid: boolean;
        modifyPassphrase: boolean;
        changeModifyPassphrase: () => void;
    }

    export interface ITakeAllModalScope extends ng.IScope{
        takeModalInput: ITakeAllModalInput;
        connectedBlocks: IConnectedBlocksMap;
        THUMBNAIL_FAIL_IMG: string;
        modalClose: (userResponse: boolean) => void;
        dropLock: () => void;
        warningMessage: string;
        connectionValid: boolean;
        messageType: string;
        validationIsTakingTooLong: boolean;
        validationIsTakingTooLongMessage: string;
        validated: boolean;
        matrixRoom: MatrixRoom;
        ready: boolean;
        validatePath: (sourceId: number, sinkId: number, previousSourceid: number) => void;
        selectedConnectionRoomGroup?: Models.ConnectionRoomGroup;
        drop: boolean;
    }

    /**
     * VideoPlayerModalController class
     */
    export class TakeModalController {
        public static templateUrl: string = "decorators/modals/take-modal.html";
        public static ID: string = "#id-take-modal";
        public static $name: string = "takeModal";
        public static $inject: string[] = ['$scope',
                                           'close',
                                           'takeInputs',
                                           'connectionRoomService',
                                           'messageTranslationsService',
                                           '$rootScope',
                                           '$timeout',
                                           'presetPathService',
                                           'blockConnectionBlocksService',
                                           'blockService',
                                            'streamPipeService',
                                           ];

        private scope: ITakeModalScope;
        private close: (userAction: {}) => void;
        private presetPathConnection: Models.IBlockConnection;

        private readonly DEFAULT_LATENCY = 4000;
        private disablePassphraseMod = true;

        /**
         * Constructor
         */
        constructor($scope: ITakeModalScope,
                    close: () => void,
                    takeInputs: ITakeModalInput,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private $rootScope: Services.IFlexSettings,
                    private $timeout: ng.ITimeoutService,
                    private presetPathService: Services.PresetPathService,
                    private blockConnectionBlockService: Services.BlockConnectionBlocksService,
                    private blockService: Services.BlockService,
                    private streamPipeService: Services.StreamPipeService) {
            this.scope = $scope;
            this.scope.THUMBNAIL_FAIL_IMG = "images/thumbnail-fail.png";
            this.scope.takeModalInput = takeInputs;
            this.scope.messageType = undefined;
            this.scope.validationIsTakingTooLongMessage = "This is taking longer than usual. You might have a connectivity problem.";
            this.close = close;
            this.scope.latency = this.DEFAULT_LATENCY;
            this.scope.useRedundancy = true;
            this.scope.passphraseError = false;
            this.scope.ipAddressError = false;
            this.scope.portError = false;
            this.scope.latencyError = false;
            this.scope.lockedComment = "";
            this.scope.lockedDestination = false;
            this.scope.isRedundantValid = false;
            this.scope.secondaryTakeId;

            const hasSrc = this.scope.takeModalInput.src != undefined && this.scope.takeModalInput.src.name != undefined;
            const hasPrevSrc = this.scope.takeModalInput.prevSrcName && this.scope.takeModalInput.prevSrcName!= undefined;

            this.scope.isTake = hasSrc && !hasPrevSrc;
            this.scope.isSwitch = hasSrc && hasPrevSrc && this.scope.takeModalInput.src.name !== this.scope.takeModalInput.prevSrcName;
            this.initCustomParametersAttributes();

            this.scope.ready = (!this.scope.takeModalInput.src && this.scope.takeModalInput.prevSrcName) ? true : false;

            this.scope.validatePath = async (sourceId: number, sinkid: number, previousSourceid: number): Promise<void> => {
                this.connectionRoomService.validateConnection(sourceId, sinkid, previousSourceid)
                    .then(async (validation: Models.IConnectionValidation): Promise<any> => {
                        this.scope.validationIsTakingTooLong = false;
                        this.scope.validated = true;
                        this.scope.warningMessage =
                            this.messageTranslationsService.getMessageAsStringByKeySync(validation.message, validation.params);
                        if (validation.result === 'OK' || validation.result === 'WARNING') {
                            this.scope.connectionValid = true;
                            this.scope.messageType = "information";
                            this.$rootScope.$broadcast('vars.connectionLocked', true);
                            // show setting passphrase option
                            // for this we need to check for an existing preset path in sink or source block connection
                            await this.setPassPhrase(takeInputs);
                        } else if (validation.result === 'ERROR' && validation.message.indexOf("dismiss") > -1) {
                            // do nothing, user is closing the modal.
                        } else {
                            let sourceBlock = this.scope.takeModalInput.matrixRoom.getSourceBlock(sourceId);
                            let sinkBlock = this.scope.takeModalInput.matrixRoom.getDestinationBlock(sinkid);
                            let sourceBlockStreamPipes = await this.streamPipeService.getStreamPipesByBlockList([sourceBlock.id]);
                            if(Common.Utils.strIdFromHref(sourceBlock.blockType.href) === "1" && Common.Utils.strIdFromHref(sinkBlock.blockType.href) === "3" && sourceBlockStreamPipes[0] !== undefined && sourceBlockStreamPipes[0][0] !== undefined) {
                                this.scope.warningMessage =
                                    this.messageTranslationsService.getMessageAsStringByKeySync("Cannot complete the connection since this source already in another connection. You must drop first. Switch not authorised.", validation.params);
                            }
                            this.scope.connectionValid = false;
                            this.scope.messageType = "error";
                        }
                        this.scope.ready = true;
                    });
                this.$timeout(() => {
                    if (!this.scope.validated) {
                        this.scope.validationIsTakingTooLong = true;
                    }
                }, 4000);
            };
            
            this.scope.validatePathWithRedundancy = (sourceId: number, sinkid: number, previousSourceid: number, secondarySourceId: number): void => {
                let prevSecondarySrcId = undefined;
                if (takeInputs.prevSrcId !== undefined && this.scope.takeModalInput.matrixRoom.matrixRoomConnectedBlocks[takeInputs.dst.id].length > 1) {
                    let prevSrcBlock: IBlockComplete = this.scope.takeModalInput.matrixRoom.getSourceBlock(takeInputs.prevSrcId);
                    prevSecondarySrcId = Common.Utils.getRedundantIdFromEncoderGroup(prevSrcBlock);
                }
                this.connectionRoomService.validateConnection(secondarySourceId, takeInputs.dst.config.redundantBlockId, prevSecondarySrcId)
                    .then((validation: Models.IConnectionValidation) => {
                        this.connectionRoomService.validateConnection(takeInputs.src.id, takeInputs.dst.id, takeInputs.prevSrcId)
                            .then((validation: Models.IConnectionValidation) => {
                                this.scope.validationIsTakingTooLong = false;
                                this.scope.validated = true;
                                this.scope.warningMessage =
                                    this.messageTranslationsService.getMessageAsStringByKeySync(validation.message, validation.params);
                                if (validation.result === 'OK' || validation.result === 'WARNING') {
                                    this.scope.connectionValid = true;
                                    this.scope.messageType = "information";
                                    this.$rootScope.$broadcast('vars.connectionLocked', true);
                                } else if (validation.result === 'ERROR' && validation.message.indexOf("dismiss") > -1) {
                                    // do nothing, user is closing the modal.
                                } else {
                                    this.scope.connectionValid = false;
                                    this.scope.messageType = "error";
                                }
                            });
                        this.scope.ready = true;
                    });
                this.$timeout(() => {
                    if (!this.scope.validated) {
                        this.scope.validationIsTakingTooLong = true;
                    }
                }, 4000);
            };


            if (takeInputs.src !== undefined && takeInputs.src.id !== undefined &&
                takeInputs.dst !== undefined && takeInputs.dst.id !== undefined) {

                    // if checkbox is checked in take modal
                if (this.scope.useRedundancy) {
                    // If sink is a DR5000 with redundancy and source has a redundancyGroup associated
                    if (takeInputs.dst.config.isRedundant !== undefined && takeInputs.src.config.redundancyGroup !== undefined) {
                        // find the secondary source for the redundant take
                      this.scope.secondaryTakeId = Common.Utils.getRedundantIdFromEncoderGroup(takeInputs.src);
                        //check if secondary encoder block is matrix room
                        this.scope.isRedundantValid = this.scope.takeModalInput.matrixRoom.getSourceBlock(Number(this.scope.secondaryTakeId)) !== undefined;
                    }
                }
                // if we have valid redundant take, proceed with validation
                if(this.scope.isRedundantValid){
                    this.scope.validatePathWithRedundancy(takeInputs.src.id, takeInputs.dst.id, takeInputs.prevSrcId, this.scope.secondaryTakeId);
                }else{
                    // normal take validation
                    this.scope.validatePath(takeInputs.src.id, takeInputs.dst.id, takeInputs.prevSrcId);
                }
            } else if (takeInputs.dst !== undefined && takeInputs.prevSrcId !== undefined && takeInputs.src === undefined) {
                this.scope.connectionValid = true;
                this.scope.messageType = "information";
                this.$rootScope.$broadcast('vars.connectionLocked', true);
            } else {
                this.scope.connectionValid = false;
                this.scope.warningMessage = "Non defined reason";
                this.scope.messageType = "error";
            }

            this.scope.dropLock = (): void => {
                this.connectionRoomService.cancelValidation();
                if (takeInputs.src !== undefined && takeInputs.src.id !== undefined &&
                    takeInputs.dst !== undefined && takeInputs.dst.id !== undefined) {

                    this.connectionRoomService.dropLock(takeInputs.src.id, takeInputs.dst.id);
                } else {
                    this.connectionRoomService.dropLock();
                }
                this.$rootScope.$broadcast('vars.connectionLocked', false);
                this.scope.modalClose(false);

            };

            /**
             * when closing modal, we send presetPath info in case there is one, otherwise, send userResponse
             *  (boolean to check if modal is closed by clicking on continue button)
             */
            this.scope.modalClose = (userResponse: boolean): void => {

                let fieldsErrors = false;

                let userAction = { userResponse: userResponse, customParameters: {}, presetPathConnection: {}, lockedComment: "", dst: <IBlock>{} };
                if (hasSrc && this.scope.takeModalInput.hasCustomTakeParameters) {
                    const passphrase = this.scope.passphrase && !this.scope.passphraseError ? this.scope.passphrase : undefined;

                    const ip: string = this.scope.ip ? this.scope.ip : undefined;
                    const port: number = this.scope.port ? this.scope.port : Models.DEFAULT_PORT;
                    const latency: number = this.scope.latency ? this.scope.latency : undefined;

                    fieldsErrors = this.areFieldsInvalid();

                    userAction.customParameters = {ip: ip,port:  port, latency: latency, passphrase: passphrase};
                } else if(angular.equals(this.presetPathConnection, {}) || this.presetPathConnection == undefined){
                    userAction.presetPathConnection = {};
                } else{
                    // we update new passphrase in presetPath connection
                    const passphrase = this.scope.passphrase && !this.scope.passphraseError ? this.scope.passphrase : undefined;
                    this.presetPathConnection.parameters.passphrase =  this.scope.modifyPassphrase && passphrase ? this.scope.passphrase : undefined;
                    userAction.presetPathConnection = this.presetPathConnection;

                    //if lock option is checked, update block with lock info and comment
                    if(this.scope.lockedDestination){
                        userAction.lockedComment = this.scope.lockedComment;
                        userAction.dst = takeInputs.dst;
                    }

                }
                if(!userResponse || (userResponse && !fieldsErrors) || (!this.scope.isTake && !this.scope.isSwitch))
                    this.close(userAction);
            };

            this.scope.updatingPass = (newPassphrase: any): void => {
                this.checkPassphrase(newPassphrase);
                this.scope.passphrase = this.scope.passphraseError ? this.scope.passphrase : newPassphrase;
            }

            this.scope.updatingIp = (newIp: any): void => {
                this.scope.ip = newIp;
                this.checkIpAddress();
            }

            this.scope.updatingPort = (newPort: any): void => {
                this.scope.port = newPort;
                this.checkPort();
            }

            this.scope.updatingLatency = (newLatency: any): void => {
                this.scope.latency = newLatency;
                this.checkLatency();
            }

            this.scope.updateLockedComment = (lockedComment: string): void => {
                this.scope.lockedComment = lockedComment;
            }

            this.scope.updateLockedDestination = (lockedDestination: boolean): void => {
                this.scope.lockedDestination = lockedDestination;
            }

            // show or hide redundant option
            // Add check to make sure both encoders that are being connected to the DR5000 with redundancy are in matrix room
            this.scope.checkRedundancy = (): boolean => {
                if(this.scope.takeModalInput.src !== undefined) {
                    let sourceBlock: IBlock = this.scope.takeModalInput.matrixRoom.getSourceBlock(this.scope.takeModalInput.src.id);
                    if (sourceBlock.config.redundancyGroup) {
                        let secondaryTake = Common.Utils.getRedundantIdFromEncoderGroup(takeInputs.src);
                        if (this.scope.takeModalInput.dst.config.isRedundant !== undefined  && this.scope.takeModalInput.src.config.redundancyGroup !== undefined
                            && this.scope.takeModalInput.matrixRoom.getSourceBlock(Number(secondaryTake)) !== undefined ) {
                            return true;
                        }
                    }
                }
                return false;
            }

            this.scope.showPassphrase = (): boolean => {
                return this.scope.ready
                    && (this.scope.isTake || this.scope.isSwitch)
                    && (this.scope.passphrase != undefined || this.scope.takeModalInput.hasCustomTakeParameters)
                    && (!this.disablePassphraseMod || this.scope.takeModalInput.hasCustomTakeParameters);
            }

            this.scope.showLockDestination = (): boolean => {
                return this.scope.ready && this.scope.passphrase != undefined && !this.scope.takeModalInput.hasCustomTakeParameters
            };

            this.scope.changeRedundancy = (): void => {
                this.scope.useRedundancy = !this.scope.useRedundancy;
            };

            this.scope.changeModifyPassphrase = (): void => {
                this.scope.modifyPassphrase = !this.scope.modifyPassphrase;
            };
        }

        private initCustomParametersAttributes() {
            this.scope.showCustomParameters = (this.scope.isTake || this.scope.isSwitch) && this.scope.takeModalInput.hasCustomTakeParameters;
            // this is to show the modify passphrase when the node is not VSRT listerner and to init to false (uncheck by default)
            this.scope.modifyPassphrase = this.scope.showCustomParameters;

            if (!this.scope.showCustomParameters) {
                return;
            }
            const isSrc = this.scope.takeModalInput.customTakeParametersInSrc;

            const block = isSrc ? this.scope.takeModalInput.src : this.scope.takeModalInput.dst;

            const connectionDirection = isSrc ? BlockConnections.DIRECTION_OUTPUT : BlockConnections.DIRECTION_INPUT;
            const blockConnection = block.blockConnections.filter(connection => connection.direction === connectionDirection)[0];

            this.scope.ip = block.config.ip;
            this.scope.port = isSrc ? +block.config.outputTargetPort : +block.config.inputTargetPort;
            this.scope.latency = +block.config.latency;
            this.scope.passphrase = blockConnection.parameters.passphrase;
        }

        /**
         * check for preset path in source and sink, if so, show passphrase set option
         * @param takeInputs 
         */
        async setPassPhrase(takeInputs: ITakeModalInput): Promise<void>{
            let sourceHasPresetPath: Boolean = false;
            if(this.checkIfVirtSrtRxCall(takeInputs.dst)){
                this.presetPathConnection = await this.checkPresetPath(null, takeInputs.dst);
                if(!angular.equals(this.presetPathConnection, {})){
                 this.scope.passphrase = this.presetPathConnection.parameters.passphrase ? this.presetPathConnection.parameters.passphrase : "";
                 this.scope.updatingPass(this.scope.passphrase);
                 sourceHasPresetPath = true;
               }
            }

            if(this.checkIfSrtSource(takeInputs.src)){
                this.presetPathConnection = await this.checkPresetPath(takeInputs.src, null);
                if(!angular.equals(this.presetPathConnection, {})){
                    // checking if take has 2 preset paths involved, if so, remove passphrase set option
                    if(sourceHasPresetPath == true) {
                        this.scope.passphrase = undefined; console.log("two preset paths involved, is not supported");
                        this.scope.passphraseError = false;
                        return;
                    }
                    this.scope.passphrase = this.presetPathConnection.parameters.passphrase ? this.presetPathConnection.parameters.passphrase : "";
                    this.scope.updatingPass(this.scope.passphrase);
                }                            
             }

        }

        areFieldsInvalid() {
            this.checkIpAddress();
            this.checkPort();
            this.checkLatency();
            this.checkPassphrase(this.scope.passphrase);

            return this.scope.ipAddressError || this.scope.portError || this.scope.latencyError || this.scope.passphraseError;
        }

        checkIpAddress() {
            this.scope.ipAddressError =  !Common.Utils.validateIPAddress(this.scope.ip);
        }

        checkPort() {
            this.scope.portError = !this.scope.port || !this.isValueInRange(this.scope.port, 1, 65535);
        }

        checkLatency() {
            this.scope.latencyError = this.scope.latency == undefined || this.scope.latency < 0;
        }

        checkPassphrase(newPassphrase: string) {
            this.scope.passphraseError = !newPassphrase || newPassphrase.length < 10 || this.validatePassphraseChars(newPassphrase);
        }

        validatePassphraseChars(passphrase: string) {
            return passphrase.indexOf('=') !== -1 || passphrase.indexOf('&') !== -1 || passphrase.indexOf('?') !== -1;
        }

        isValueInRange(value: number, rangeMin: number, rangeMax: number) {
            return value && value >=rangeMin && value <= rangeMax;
        }

        checkIfVirtSrtRxCall(destBlock: IBlock): boolean{
            return destBlock.networkNodeTypeHref == "20";
        }

        // we have to add all srt type origin nodes, virt_srt_tx_call and makito for now
        checkIfSrtSource(sourceBlock: IBlock):boolean{
            return sourceBlock.networkNodeTypeHref == "23" || sourceBlock.networkNodeTypeHref == "21";
        }

        // NOTE: this won't work with pipes with two preset paths involved
        async checkPresetPath(srcBlock: IBlock, sinkBlock: IBlock): Promise<Models.IBlockConnection>{
            let blockToCheck = srcBlock != null ? srcBlock : sinkBlock;
            let presetPath = await this.presetPathService.getStickyConnectionsByBlockId(blockToCheck.id);
            if(presetPath.length > 0){
                const presetPathBlockConnection = srcBlock != null ? presetPath[0].destBlockConnection: presetPath[0].origBlockConnection;
                let node = await this.blockService.getNodeFromBlockName(presetPathBlockConnection.blockName);
                this.disablePassphraseMod = node.config.disablePassphraseMod;
                return presetPathBlockConnection;
            } else {
                return new Promise<Models.IBlockConnection>((resolve: Function) => {
                    resolve({});
                });
            }
        } 
    }
}
